import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-coop',
  templateUrl: './coop.component.html',
  styleUrls: ['./coop.component.css']
})
export class CoopComponent implements OnInit {
    public coopId;

    public edit?: Edit;

    public saving = false;

    public coopNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'cooplangs', gotoParms: () => this.edit!.coop_id ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.coopId = this.stateService.getStateParams()['coop_id'];
    }

    private async loadEdit() {
        if (!!this.coopId) {
            this.edit = (await this.datatask.Post(2728, { coop_id: this.coopId }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2729, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    coop_id: string;
    coop_name: string;
    isactive: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('coop', {
//        templateUrl: 'views/components/views/coop/coop.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'coopService', function ($stateParams, stateService, translateService, modalService, coopService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let coopId = $stateParams.coop_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                coopId: coopId,
//                coopNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('cooplangs', { coop_id: vm.model.edit.coop_id }) }
//                ],
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await coopService.getCoop({ coop_id: coopId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                coopService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
